import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Phone, Mail, MapPin, Printer, User } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-12">
        {/* Page Title */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#000066] mb-3">Contact Us</h1>
          <div className="h-1 w-32 bg-[#FF4500] mx-auto"></div>
          <p className="text-gray-600 mt-4">Get in touch with us for any inquiries or information</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Contact Information Card */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#000066] mb-6 flex items-center gap-2">
              <User className="w-6 h-6 text-[#FF4500]" />
              Principal's Office
            </h2>

            <div className="space-y-6">
              {/* Principal Name */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-1">Dr. S. V. Shinde</h3>
                <p className="text-gray-600 text-sm">I/C Principal</p>
              </div>

              {/* Address */}
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FF4500] mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Address</h4>
                  <p className="text-gray-700 leading-relaxed">
                    D.A.V. Velankar College Of Commerce,<br />
                    Maharshi Dayanand Chowk, Dayanand Nagar,<br />
                    Raviwar Peth, Solapur (MS) - 413002
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#FF4500] mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Office Phone</h4>
                  <a 
                    href="tel:02172323194" 
                    className="text-[#000066] hover:text-[#FF4500] transition-colors font-medium"
                  >
                    0217-2323194
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#FF4500] mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">E-Mail</h4>
                  <a 
                    href="mailto:davvccsolapur371@gmail.com" 
                    className="text-[#000066] hover:text-[#FF4500] transition-colors font-medium break-all"
                  >
                    davvccsolapur371@gmail.com
                  </a>
                </div>
              </div>

              {/* Fax */}
              <div className="flex items-start gap-3">
                <Printer className="w-5 h-5 text-[#FF4500] mt-1 flex-shrink-0" />
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">FAX Number</h4>
                  <p className="text-gray-700 font-medium">(0217) 2728900</p>
                </div>
              </div>
            </div>
          </div>

          {/* Map/Additional Info Card */}
          <div className="bg-gradient-to-br from-[#000066] to-[#000099] rounded-lg shadow-lg p-8 text-white">
            <h2 className="text-2xl font-bold mb-6">Office Hours</h2>
            
            <div className="space-y-4 mb-8">
              <div className="border-l-4 border-[#FFD700] pl-4">
                <h3 className="font-semibold text-lg mb-1">Monday - Friday</h3>
                <p className="text-gray-200">9:00 AM - 5:00 PM</p>
              </div>
              
              <div className="border-l-4 border-[#FFD700] pl-4">
                <h3 className="font-semibold text-lg mb-1">Saturday</h3>
                <p className="text-gray-200">9:00 AM - 1:00 PM</p>
              </div>
              
              <div className="border-l-4 border-[#FFD700] pl-4">
                <h3 className="font-semibold text-lg mb-1">Sunday</h3>
                <p className="text-gray-200">Closed</p>
              </div>
            </div>

            <div className="bg-white/10 rounded-lg p-6 backdrop-blur">
              <h3 className="font-semibold text-lg mb-3">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-[#FFD700] transition-colors flex items-center gap-2">
                    → Admission Inquiry
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-[#FFD700] transition-colors flex items-center gap-2">
                    → General Information
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-[#FFD700] transition-colors flex items-center gap-2">
                    → Faculty Directory
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-[#FFD700] transition-colors flex items-center gap-2">
                    → Campus Facilities
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Google Maps Section */}
        <div className="mt-12 max-w-6xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6 bg-gradient-to-r from-[#000066] to-[#000099]">
              <h2 className="text-2xl font-bold text-white flex items-center gap-2">
                <MapPin className="w-6 h-6" />
                Find Us on Map
              </h2>
            </div>
            <div className="relative w-full h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.7654321!2d75.9063889!3d17.6739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDQwJzI2LjAiTiA3NcKwNTQnMjMuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="DAV Velankar College Location"
                className="absolute inset-0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Contact;
